import { AxiosError } from 'axios';
import Environment from '../../shared/constants/Environment';
import AxiosFlexeServeInstance from '../shared/AxiosFlexeServe';
import { ControlUnitTranslationAPIResponse } from './CUTranslation.model';

const backendAPITranslation = Environment.backendAPITranslation;

/**
 * Model interface class:
 * this class get the data from the backend for frontend service and use
 * the corresponding class (Group, Device, User, Right) to transfor it
 */
class CUTranslationCalls {
  constructor(private axios = AxiosFlexeServeInstance) {}

  /**
   * Get events by devices id
   * @param array devicesIds
   */
  async getTranslationByControlUnit(
    commanderId: string,
    controlUnitId: number | string
  ) {
    const url = `${backendAPITranslation}/${commanderId}/${controlUnitId}`;

    return this.axios
      .get<ControlUnitTranslationAPIResponse>(url)
      .then((response) => response.data)
      .catch((error: AxiosError) => {
        if (error.response?.status === 404) {
          return undefined;
        } else {
          return Promise.reject(error);
        }
      });
  }
}

export default CUTranslationCalls;
